import React from 'react';
import { IntlShape } from 'react-intl';
import { T, useT } from '@transifex/react';
import { Typography } from '@raisin/components-lib';
import { DEPOSIT_PRODUCT_TYPE, DepositTakingBank } from '../types';
import * as S from './styles';

export interface RiskBannerProps {
  productType: `${DEPOSIT_PRODUCT_TYPE}`;
  formatNumber: IntlShape['formatNumber'];
  depositTakingBank: DepositTakingBank;
  isEarlyTerminationAvailable: boolean;
  content: {
    riskBannerMainHeading: string;
    riskBannerStatutoryGuaranteeText: string;
    riskBannerEarlyTerminationAvailableText: string;
    riskBannerEarlyTerminationNotAvailableText: string;
  };
}

export function RiskBanner({
  productType,
  formatNumber,
  depositTakingBank,
  isEarlyTerminationAvailable,
  content,
}: RiskBannerProps) {
  const t = useT();
  const {
    name: bankName,
    statutoryDepositGuaranteeScheme: { insuredAmount, currency, country },
  } = depositTakingBank;
  const {
    riskBannerMainHeading,
    riskBannerStatutoryGuaranteeText,
    riskBannerEarlyTerminationNotAvailableText,
  } = content;

  return (
    <S.RiskBannerContainer hasTerminationSection={productType === DEPOSIT_PRODUCT_TYPE.TERM}>
      <S.RiskBannerMainSection>
        <S.RiskBannerRatingContainer>
          <Typography variant="h3">
            <span>1</span>/6
          </Typography>
        </S.RiskBannerRatingContainer>
        <S.RiskBannerSectionText mainSection variant="body2">
          <T _str={riskBannerMainHeading} />
        </S.RiskBannerSectionText>
      </S.RiskBannerMainSection>

      <S.RiskBannerSection>
        <S.RiskBannerSectionText variant="body2">
          <T
            _str={riskBannerStatutoryGuaranteeText}
            BANK_NAME={bankName}
            DGS_COUNTRY={country?.name}
            DGS_AMOUNT={formatNumber(insuredAmount)}
            CURRENCY={currency}
          />
        </S.RiskBannerSectionText>
      </S.RiskBannerSection>

      {!isEarlyTerminationAvailable && (
        <S.RiskBannerSection earlyTerminationSection={true} data-testid="earlyTerminationSection">
          <S.RiskBannerSectionText variant="body2">
            {t(riskBannerEarlyTerminationNotAvailableText, {
              ICON: (
                <S.RiskBannerLockIconSet>
                  <img src="/cp_assets/lock.svg" alt="lock-icon" />
                  <img src="/cp_assets/lock.svg" alt="lock-icon" />
                </S.RiskBannerLockIconSet>
              ),
            })}
          </S.RiskBannerSectionText>
        </S.RiskBannerSection>
      )}
    </S.RiskBannerContainer>
  );
}
